import { Link } from "react-router";
import { TheAdamMark } from "@/components/brand";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 p-6 text-center">
      <TheAdamMark />
      <div>
        <p className="text-sm font-medium text-muted-foreground">404</p>
        <h1 className="mt-1 text-2xl font-semibold">Sayfa bulunamadı</h1>
        <p className="mt-2 text-sm text-muted-foreground">Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.</p>
      </div>
      <Button asChild>
        <Link to="/">Panele dön</Link>
      </Button>
    </div>
  );
}
